/**
 * @generated SignedSource<<e4079842eb47115adf7e93781ad329f1>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a

import type { ConcreteRequest } from 'relay-runtime';
export type ContentHeaderPresenceContentSettingsQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type ContentHeaderPresenceContentSettingsQuery$data = {
  readonly confluence_teamPresenceContentSetting: {
    readonly isEnabledOnContentView: boolean;
  } | null | undefined;
};
export type ContentHeaderPresenceContentSettingsQuery = {
  response: ContentHeaderPresenceContentSettingsQuery$data;
  variables: ContentHeaderPresenceContentSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceTeamPresence",
    "kind": "LinkedField",
    "name": "confluence_teamPresenceContentSetting",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isEnabledOnContentView"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentHeaderPresenceContentSettingsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentHeaderPresenceContentSettingsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
    "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
    "metadata": {},
    "name": "ContentHeaderPresenceContentSettingsQuery",
    "operationKind": "query",
    "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
  }
};
})();

(node as any).hash = "d0f958354cdf65029012c243a64d4874";

export default node;
